import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=6e6afff4&scoped=true&"
import script from "./factory.vue?vue&type=script&lang=js&"
export * from "./factory.vue?vue&type=script&lang=js&"
import style1 from "./factory.vue?vue&type=style&index=1&id=6e6afff4&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6afff4",
  null
  
)

export default component.exports